var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlob(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 561,
    height: 592,
    viewBox: "0 0 561 592",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294.693 305.821C284.89 303.194 280.208 293.437 282.82 283.689C285.432 273.94 294.365 267.835 304.168 270.462C313.971 273.089 319.82 283.154 317.208 292.903C314.592 302.651 304.492 308.447 294.693 305.821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.875 330.014C375.076 327.389 369.226 317.323 371.838 307.574C374.449 297.83 384.55 292.03 394.349 294.655C404.152 297.282 408.835 307.039 406.223 316.788C403.614 326.538 394.678 332.641 384.875 330.014Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.668 442.308C355.966 495.478 273.568 520.395 179.483 517.066C85.3983 513.738 39.4644 465.371 41.6871 371.975C43.9109 278.575 69.8804 200.248 119.597 136.988C169.313 73.7283 240.547 47.4944 333.301 58.2822C426.055 69.07 482.48 122.48 502.577 218.507C522.673 314.538 497.369 389.138 426.668 442.308Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob);
export default __webpack_public_path__ + "static/media/blob.b24393a0aa618160b3b8f2d97a43923c.svg";
export { ForwardRef as ReactComponent };